import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

import AddApp from '@/assets/icons/AddApp';
import { GX_TEXT } from '@/config/colors';
import { ButtonsContainer } from '@/features/dashboard/components/Drawer/components/ButtonsContainer';
import {
  DrawerStep,
  useDrawerSteps
} from '@/features/dashboard/components/Drawer/context/DrawerStepsContext';
import { DashboardStep } from '@/features/dashboard/constants/DashboardStep';
import { DASHBOARD_ACTION_BUTTON_WIDTH } from '@/features/dashboard/constants/style';
import { useDashboardEditLockContext } from '@/features/dashboard/state/DashboardEditLockContext';
import Button from '@/shared/ui/primitives/Button';

export const DashboardActionButtons = ({
  setStep,
  onEditClick,
  children
}: {
  setStep: (step: DashboardStep) => void;
  /** Overrides the Edit button's default behavior (entering Edit mode). Used for
   * an empty dashboard, where there is nothing to edit yet and Edit should open
   * the Add app drawer instead. */
  onEditClick?: () => void;
  children?: React.ReactNode;
}) => {
  const { setDrawerStep } = useDrawerSteps();
  const { requestEditLock } = useDashboardEditLockContext();

  const handleAddApp = () => {
    requestEditLock(() => {
      setDrawerStep(DrawerStep.SelectApp);
    });
  };

  const handleEdit = onEditClick ?? (() => setStep(DashboardStep.Edit));

  return (
    <ButtonsContainer>
      {children}
      <Button
        color='secondary'
        size='large'
        startIcon={<EditOutlinedIcon />}
        sx={{
          width: DASHBOARD_ACTION_BUTTON_WIDTH
        }}
        variant='contained'
        onClick={handleEdit}
      >
        Edit
      </Button>
      <Button
        color='secondary'
        size='large'
        startIcon={<AddApp fill={GX_TEXT} />}
        sx={{
          width: DASHBOARD_ACTION_BUTTON_WIDTH
        }}
        variant='contained'
        onClick={handleAddApp}
      >
        Add app
      </Button>
    </ButtonsContainer>
  );
};
